




import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';

@Component
export default class LangSelect extends Vue {
  get isLanguageForZh() {
    return AppModule.language === 'zh';
  }
  private changeLang() {
    let language = '';
    if (this.isLanguageForZh) {
      language = 'en';
    } else {
      language = 'zh';
    }
    this.$i18n.locale = language;
    AppModule.SetLanguage(language);
    document.documentElement.lang = language;
  }
}
